import React, { useCallback, useMemo, useState } from 'react';

import { Grid, IconButton, InputAdornment, TextField, makeStyles, MenuItem, Select, Button } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => {
  return {
    categoryId: {
      width: '100%',
    },
    categoryIdContainer: {
      alignItems: 'center',
      display: 'flex',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '250px',
      },
    },
    categoryIdParentContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '24px',
    },
    chkBoxSvg: {
      '& path': {
        outline: '3px solid rgba(0, 0, 0, 0.54)',
      },
    },
    filterField: {
      width: '100%',
    },
    filtersContainer: {
      marginLeft: 'auto',
      marginTop: '16px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '300px',
      },
    },
    list: {
      paddingBottom: 0,
      paddingTop: 0,
    },
    menu: {
      border: '2px solid #E7E7E7',
      borderRadius: '5px',
      boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
      paddingBottom: '1rem',
    },

    searchContainer: {
      marginTop: '16px',
      [theme.breakpoints.up('md')]: {
        maxWidth: '300px',
      },
    },
    searchField: {
      width: '100%',
    },
  };
});

export default ({ onSearchChange, categoryList }) => {
  const classes = useStyles();
  const [keyword, setKeyword] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const categories = useMemo(() => {
    return categoryList || [];
  }, [categoryList]);

  const filterRenderValue = useCallback(
    (value) => {
      if (!value) return <span style={{ color: '#999999' }}>Filter by Category</span>;

      const selectedCategory = categories.find((data) => data.id === value);
      return selectedCategory.name;
    },
    [categories]
  );

  const handleSearchChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleCategoryIdChange = (e) => {
    setCategoryId(e.target.value);
    handleUpdateSelfhelpCategoryId(e.target.value);
  };

  const handleCategoryIdClear = () => {
    setCategoryId('');
    setKeyword('');
    if (onSearchChange) onSearchChange({ keyword: '', selfHelpCategoryId: '' });
  };

  const handleSearchClick = () => {
    if (onSearchChange) onSearchChange({ keyword });
  };

  const handleUpdateSelfhelpCategoryId = (value) => {
    if (onSearchChange) onSearchChange({ selfHelpCategoryId: value });
  };

  return (
    <Grid container alignItems="center">
      <Grid item xs={12} md={6} className="text-left">
        <div className={classes.searchContainer}>
          <TextField
            className={classes.searchField}
            onChange={handleSearchChange}
            onKeyUp={(evt) => {
              if (evt.key === 'Enter') {
                handleSearchClick();
              }
            }}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment>
                  <IconButton edge="start" onClick={handleSearchClick}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={keyword}
            type="text"
          />
        </div>
      </Grid>
      <Grid item xs={12} md={6}>
        <div className={classes.categoryIdParentContainer}>
          <div className={classes.categoryIdContainer}>
            <Select
              displayEmpty
              renderValue={filterRenderValue}
              className={`${classes.categoryId} bold-icon no-background-focus`}
              name="selectedFilter"
              onChange={handleCategoryIdChange}
              value={categoryId}>
              {categories.map((category) => {
                const key = `self-help-category--content-filters--${category.id}`;
                return (
                  <MenuItem key={key} value={category.id}>
                    {category.name}
                  </MenuItem>
                );
              })}
            </Select>

            {!!categoryId && (
              <Button size="small" onClick={handleCategoryIdClear} variant="outlined" style={{ marginLeft: '8px', width: '124px' }}>
                Clear filter
              </Button>
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};
